import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PinMap } from '@awaze/design-system.components.icon';
import { Text } from '@awaze/design-system.components.text';
import { AutocompleteListItemTextWrapper, StyledButton, } from './autocomplete.styles';
export const buttonProtoProps = {
    type: 'button',
    size: 'small',
    variant: 'solid',
    colourScheme: 'brand-tertiary',
    iconPosition: 'right',
    justify: 'space-between',
    icon: _jsx(PinMap, {}),
    fullWidth: true,
    isFullWidth: true,
};
export const AutocompleteListItem = ({ inlineResults, handleItemOnClick, name, keyDown, subtitle = null, ...rest }) => {
    return (_jsx(StyledButton, { ...buttonProtoProps, "data-testid": "search-form-autocomplete-result", text: _jsxs(AutocompleteListItemTextWrapper, { children: [_jsx(Text, { sizes: 200, type: "mid", children: name }), subtitle && (_jsx(Text, { sizes: 100, color: "ColorGrey500", children: subtitle }))] }), tabIndex: 0, title: name, onClick: handleItemOnClick, onKeyDown: keyDown, inlineResults: inlineResults, subtitle: subtitle, role: "listitem", ...(inlineResults && { variant: 'ghost' }), ...(inlineResults && { colourScheme: 'brand-primary' }), ...rest }));
};
//# sourceMappingURL=autocomplete-list-item.js.map